import { render, staticRenderFns } from "./ruleTiger.vue?vue&type=template&id=8e7c5596&scoped=true"
import script from "./ruleTiger.vue?vue&type=script&lang=js"
export * from "./ruleTiger.vue?vue&type=script&lang=js"
import style0 from "./ruleTiger.vue?vue&type=style&index=0&id=8e7c5596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7c5596",
  null
  
)

export default component.exports